<span class="state" [ngClass]="getStateClass(state)" *ngIf="!compact; else icons;">
    <span>{{ state }}</span>
    <mat-icon *ngIf="state === WorkflowExecutionState.pending">more_horiz</mat-icon>
    <mat-icon *ngIf="state === WorkflowExecutionState.started">play_arrow</mat-icon>
    <mat-icon *ngIf="state === WorkflowExecutionState.completed">check</mat-icon>
    <mat-icon *ngIf="state === WorkflowExecutionState.cancelled">close</mat-icon>
</span>

<ng-template #icons>
    <span class="state" [ngClass]="getStateClass(state)">
        <!-- <mat-icon *ngIf="state === WorkflowExecutionState.pending">hourglass_empty</mat-icon> -->
        <fa-icon *ngIf="state === WorkflowExecutionState.pending" icon="hourglass-half"></fa-icon>
        <mat-icon *ngIf="state === WorkflowExecutionState.started">play_arrow</mat-icon>
        <mat-icon *ngIf="state === WorkflowExecutionState.completed">check</mat-icon>
        <mat-icon *ngIf="state === WorkflowExecutionState.cancelled">close</mat-icon>
    </span>
</ng-template>
